import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreeMultiselect = _resolveComponent("TreeMultiselect")!
  const _component_InputBlock = _resolveComponent("InputBlock")!

  return (_openBlock(), _createBlock(_component_InputBlock, { title: "ОКАТО лица отв. за фин. рег." }, {
    default: _withCtx(() => [
      _createVNode(_component_TreeMultiselect, {
        modelValue: _ctx.responsibleOkatoAccessor,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.responsibleOkatoAccessor) = $event)),
        options: _ctx.getOkatoTree,
        disabled: _ctx.disabled,
        valueProp: "id",
        labelProp: "name",
        menuMode: _ctx.menuModes.COMBINED_MODAL,
        getLabel: _ctx.getProductsWithSignsLabel
      }, null, 8, ["modelValue", "options", "disabled", "menuMode", "getLabel"])
    ]),
    _: 1
  }))
}